import { Component } from '@angular/core';
import { CommonService } from '../shared/common.service'; // adjust path if needed
import { Router } from '@angular/router'; // ✅ import router
import { ToastService } from '../shared/toast.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
})
export class SignupComponent {
  videoUrl!: SafeResourceUrl;

  firstName = '';
  lastName = '';
  email = '';
  phoneNumber = '';
  role = 'student';
  roleChecked = true;
  password = '';
  confirmPassword = '';
  termsAccepted = false;
  showPassword = false;
  showConfirmPassword = false;

  passwordMismatchError = false;
  submitted = false;
  signupFailed = false;
  signupSuccess = false;

  constructor(
    private commonService: CommonService,
    private router: Router,
    private toast: ToastService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
     const youtubeLink = 'https://www.youtube.com/embed/rL4zzMLGBCs';
     this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(youtubeLink);
  }

  //  onRegister(): void {
  //   this.submitted = true;
  //   this.passwordMismatchError = false;

  //   // Basic form validation
  //   if (!this.firstName || !this.lastName || !this.email || !this.phoneNumber ||
  //       !this.role || !this.password || !this.confirmPassword || !this.termsAccepted) {
  //     this.toast.showError('All fields are required and Terms must be accepted');
  //     return;
  //   }

  //   if (this.password !== this.confirmPassword) {
  //     this.passwordMismatchError = true;
  //     this.toast.showError('Passwords do not match');
  //     return;
  //   }

  //   const payload = {
  //     firstName: this.firstName,
  //     lastName: this.lastName,
  //     email: this.email,
  //     phoneNumber: this.phoneNumber,
  //     role: this.role.toLowerCase(),
  //     password: this.password
  //   };

  //   console.log('Sending signup payload:', payload);

  //   this.commonService.signup(payload).subscribe({
  //     next: (res) => {
  //       console.log('Signup success:', res);

  //       // ✅ Show backend success message
  //       this.toast.showSuccess(res?.message || 'Registration successful! Please confirm your email.');

  //       // ✅ Redirect to confirmation code page
  //       setTimeout(() => {
  //         this.router.navigate(['/confirm-code'], {
  //           queryParams: { email: this.email }
  //         });
  //       }, 1000);
  //     },
  //     error: (err) => {
  //       console.error('Signup failed:', err);

  //       // ✅ Show backend error message (fallback if none)
  //       this.toast.showError(err?.error?.message || 'Registration failed. Please try again.');
  //     }
  //   });
  // }
  onRegister(): void {
    this.submitted = true;
    this.passwordMismatchError = false;

    // Reset any previous messages
    this.signupFailed = false;
    this.signupSuccess = false;

    // Validate required fields
    if (
      !this.firstName ||
      !this.lastName ||
      !this.email ||
      !this.phoneNumber ||
      !this.role ||
      !this.password ||
      !this.confirmPassword ||
      !this.termsAccepted
    ) {
      this.toast.showError(
        'Please fill all required fields and accept Terms & Service.'
      );
      return;
    }

    if (this.password !== this.confirmPassword) {
      this.passwordMismatchError = true;
      this.toast.showError('Passwords do not match.');
      return;
    }

    // Optional: Validate email pattern (you already have pattern in HTML)
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (!emailRegex.test(this.email)) {
      this.toast.showError('Please enter a valid email address.');
      return;
    }

    // Store form data in a service or localStorage for use in package-selection
    const signupData = {
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email,
      phoneNumber: this.phoneNumber,
      role: this.role.toLowerCase(),
      password: this.password,
    };

    // Save to service (recommended) or localStorage
    this.commonService.signup(signupData); // You'll need to create this method

  }

  togglePasswordVisibility(field: 'password' | 'confirmPassword'): void {
    if (field === 'password') {
      this.showPassword = !this.showPassword;
    } else {
      this.showConfirmPassword = !this.showConfirmPassword;
    }
  }

  resetForm(): void {
    this.firstName = '';
    this.lastName = '';
    this.email = '';
    this.phoneNumber = '';
    this.role = '';
    this.password = '';
    this.confirmPassword = '';
    this.termsAccepted = false;
    this.submitted = false;
    this.passwordMismatchError = false;
  }

  toggleRole(event: any) {
    this.roleChecked = event.target.checked;
    this.role = this.roleChecked ? 'student' : '';
  }
}
